/* © 2021 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, September 17, 2021
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");


module.exports = Model({
	name: "customindicatorslist",
	init: init,
	uninit: uninit,

	_orggroup: null,
	_orggroupTracker: null,

	listeners: listeners,
	refresh: refresh
});

function init() {
	this.push([]);
	this._orggroup = null;
	this._orggroupTracker = this.dispatcher.createTracker();
	this.refresh();
}

function uninit() {
	this._orggroup = null;
	this._orggroupTracker.off();
	this._orggroupTracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"orggroup:updated": handleOrggroupUpdate,
		"mqtt:$/atouchaway/updated": handleAtouchawaySettingsUpdate,
		"mqtt:$/org/user/removed": cleanList,
	};
}

function cleanList() {
	this.push([]);
}

function refresh() {
	this.emit("save:trigger:start");
	return this.api.device.customIndicators.listAll()
		.then(setIndicators.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoading.bind(this));
}

function finishLoading() {
	this.emit("save:trigger:finish");
}

function setIndicators(indicators) {
	const indicatorsWithLocalizations = indicators.map((indicator, index) => {
		indicator = addLocalization(indicator);
		indicator["index"] = index;
		return indicator;
	});
	this.push(indicatorsWithLocalizations);
}

function handleOrggroupUpdate(orggroup) {
	if (!orggroup) return;
	const tracker = this._orggroupTracker;
	tracker.off();
	tracker.on("mqtt:orggroup/" + orggroup + "/indicators/added", handleIndicatorCreated.bind(this));
	tracker.on("mqtt:orggroup/" + orggroup + "/indicators/updated", handleIndicatorUpdated.bind(this));
	tracker.on("mqtt:orggroup/" + orggroup + "/indicators/removed", handleIndicatorRemoved.bind(this));
}

function handleIndicatorCreated(indicator) {
	const toUpdate = [...this.data, addLocalization(indicator)];
	this.push(toUpdate);
}

function handleIndicatorUpdated(indicator) {
	let toUpdate = [...this.data];
	toUpdate = this.data?.map?.((oldIndicator) => {
		let newIndicator = oldIndicator;
		const oldId = oldIndicator._id;
		if (oldId === indicator._id) newIndicator = addLocalization(indicator);
		return newIndicator;
	});
	this.push(toUpdate);
}

function handleIndicatorRemoved(indicatorId) {
	let toUpdate = [...this.data];
	const indicatorIndexToRemove = this.data?.findIndex?.(indicator => indicator._id === indicatorId);
	toUpdate?.splice?.(indicatorIndexToRemove, 1);
	this.push(toUpdate);
}

function handleAtouchawaySettingsUpdate(data) {
	if (data?.myhealth && data?.["myhealth_sections"]?.["customindicators"]) {
		this.refresh();
	} else if (data?.myhealth && data?.["myhealth_sections"]?.["customindicators"] === false) {
		this.emit("desktop:trigger:page:back");
		this.push([]);
	}
}

function addLocalization(indicator) {
	const localization = {
		"en": indicator.name,
		"fr": indicator.nameFr,
		"cn_s": indicator.nameCnS,
		"cn_t": indicator.nameCnT,
		"es": indicator.nameEs,
		"pt": indicator.namePt,
		"ta": indicator.nameTa
	};
	indicator.localization = localization;
	return indicator;
}
